import { Injectable, inject } from "@angular/core"
import { AccountInfo, AuthenticationResult, PopupRequest, RedirectRequest } from "@azure/msal-browser"
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from "@azure/msal-angular"
import { EnvService } from "./env.service"
import { LoggerService } from "./logger.service"

@Injectable({
	providedIn: "root"
})
export class AppAuthService {
	private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG)
	private authService = inject(MsalService)
	private envService = inject(EnvService)
	private loggerService = inject(LoggerService)

	public async login() {
		this.loggerService.log("auth", "start login")

		await this.loginRedirect()

		this.loggerService.log("auth", "end login")
	}

	public async loginRedirect() {
		this.loggerService.log("auth", "loginRedirect")

		await this.authService.instance.handleRedirectPromise()

		if (this.msalGuardConfig.authRequest) {
			this.authService.loginRedirect({
				...this.msalGuardConfig.authRequest
			} as RedirectRequest)
		} else {
			this.authService.loginRedirect()
		}
	}

	public loginPopup() {
		this.loggerService.log("auth", "loginPopup")

		if (this.msalGuardConfig.authRequest) {
			this.authService
				.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
				.subscribe((response: AuthenticationResult) => {
					this.authService.instance.setActiveAccount(response.account)
				})
		} else {
			this.authService.loginPopup().subscribe((response: AuthenticationResult) => {
				this.authService.instance.setActiveAccount(response.account)
			})
		}
	}

	public logout() {
		this.authService.logoutRedirect({ account: this.authService.instance.getActiveAccount() })

		/** @deprecated */
		/*
		if (popup) {
			this.authService.logoutPopup({
				mainWindowRedirectUri: this.envService.appConfig.msalConfig.auth.postLogoutRedirectUri
			})
		} else {
			this.authService.logoutRedirect()
		}
		*/
	}

	public sessionCheck() {
		const account: AccountInfo | null = this.authService.instance.getActiveAccount()

		this.loggerService.log("auth", "sessionCheck", this.authService.instance.getActiveAccount())

		if (account) {
			window.location.href = this.envService.appConfig.msalConfig.auth.redirectUri
		}
	}
}
